import React from "react";

import { useSmartrrCustomerSelector } from "@customer-app/state/typedCustomerReduxHooks";

import MagicLinkFlow from "./MagicLinkFlow";
import OTPLoginFlow from "./OTPLoginFlow";
import { PASSWORDLESS_STRATEGY } from "../libs/types";
import { smartrrDebugInfo } from "../libs/utils/smartrrDebugInfo";

smartrrDebugInfo();

export default function AuthenticationFlow({ shopifyDomain }: { shopifyDomain: string | null }): JSX.Element {
  const storeTheme = useSmartrrCustomerSelector(state => state.theme);
  const { isPasswordless, passwordlessStrategy } = storeTheme.theme;

  if (!isPasswordless) {
    return <React.Fragment />;
  }

  switch (passwordlessStrategy) {
    case PASSWORDLESS_STRATEGY.ONE_TIME_PASSWORD: {
      return <OTPLoginFlow shopifyDomain={shopifyDomain} />;
    }
    case PASSWORDLESS_STRATEGY.MAGIC_LINK: {
      return <MagicLinkFlow shopifyDomain={shopifyDomain} />;
    }
    default: {
      // Shopify's login experience is shown if no strategy / invalid strategy is selected
      return <React.Fragment />;
    }
  }
}
